/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/customPeriod.scss';

import {ChangeKeyFunction, CloseButton, WithBackground} from '@dvrd/dvr-controls';

import IDate from '@dvrd/idate';

import React, {MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {BluemateButton, DvrdDatePicker} from '../../controls';

interface Props {
    onChange: ChangeKeyFunction;
    onClose: MouseEventHandler;
    onSubmit: MouseEventHandler;
    periodStart: IDate | null;
    periodEnd: IDate | null;
    active: boolean;
    max?: IDate;
}

export default function CustomPeriod(props: Props) {
    const {t} = useTranslation();
    const {periodStart, periodEnd, active, onClose, onSubmit, onChange, max} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <DvrdDatePicker
                    onChange={onChange('start')}
                    value={periodStart}
                    label={t('salesDashboard.customPeriod.from', 'Vanaf')}
                    dateFormat='DD-MM-YYYY'
                    placeholder={t('salesDashboard.customPeriod.datePlaceholder', 'dd-mm-jjjj')}
                    max={max}
                    closeOnChange
                />
                <DvrdDatePicker
                    onChange={onChange('end')}
                    value={periodEnd}
                    label={t('salesDashboard.customPeriod.until', 'Tot en met')}
                    dateFormat='DD-MM-YYYY'
                    placeholder={t('salesDashboard.customPeriod.datePlaceholder', 'dd-mm-jjjj')}
                    max={max ?? IDate.now()}
                    closeOnChange
                />
            </div>
        );
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='custom-period default-popup'>
                <div className='header-container'>
                    <label className='header-title'>
                        {t('salesDashboard.customPeriod.title', 'Aangepaste periode')}
                    </label>
                    <CloseButton onClick={onClose} />
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BluemateButton
                        onClick={onClose}
                        label={t('salesDashboard.customPeriod.cancel', 'Annuleren')}
                        secondary
                    />
                    <BluemateButton
                        onClick={onSubmit}
                        label={t('salesDashboard.customPeriod.apply', 'Toepassen')}
                        disabled={!periodStart || !periodEnd}
                    />
                </div>
            </div>
        </WithBackground>
    );
}
